.vc-ranb-button {
    color: var(--interactive-normal);
    padding: 0 0.5em;
    width: 100%;
    box-sizing: border-box;
}

.vc-ranb-button:hover {
    color: var(--interactive-active);
}
